import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
const RequireAuth = lazy(() =>
  import('@/components/auth/RequireAuth').then((m) => ({ default: m.RequireAuth }))
);
const Login = lazy(() => import('./pages/Login'));

// The CMMSEntry already defines all /cmms/* sub-routes
// It uses ModuleLayout which renders AppHeader (logo, tenant selector, module switcher, etc.)
const CMMSEntry = lazy(() => import('@/cmms/src/CMMSEntry'));

const PageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense
    fallback={
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    }
  >
    {children}
  </Suspense>
);

export const CMMSRoutes: React.FC = () => {
  return (
    <Routes>
      {/* ── Auth ─────────────────────────────────────── */}
      <Route path="/login" element={<PageWrapper><Login /></PageWrapper>} />

      {/* ── CMMS (all /cmms/* routes) ────────────────── */}
      <Route path="/cmms/*" element={
        <RequireAuth>
          <PageWrapper>
            <CMMSEntry />
          </PageWrapper>
        </RequireAuth>
      } />

      {/* ── Redirects for routes that don't exist in this app ── */}
      <Route path="/admin/*" element={<Navigate to="/cmms" replace />} />
      <Route path="/portal/*" element={<Navigate to="/cmms" replace />} />
      <Route path="/onboarding/*" element={<Navigate to="/cmms" replace />} />
      <Route path="/comms/*" element={<Navigate to="/cmms" replace />} />

      {/* Default redirect */}
      <Route path="/" element={<Navigate to="/cmms" replace />} />
      <Route path="*" element={<Navigate to="/cmms" replace />} />
    </Routes>
  );
};
